var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 445.35 317.87",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2px;\n      }\n\n      .cls-1, .cls-2, .cls-5, .cls-9, .cls-10 {\n        fill: none;\n      }\n\n      .cls-1, .cls-4, .cls-7 {\n        stroke: #231f20;\n      }\n\n      .cls-11 {\n        fill: #a3ccff;\n      }\n\n      .cls-12 {\n        fill: #b56712;\n      }\n\n      .cls-2 {\n        stroke: #864a1f;\n      }\n\n      .cls-3 {\n        fill: #fff7db;\n        stroke: #ffc881;\n      }\n\n      .cls-13 {\n        fill: #ffa4a1;\n      }\n\n      .cls-14 {\n        fill: #231f20;\n      }\n\n      .cls-15 {\n        fill: #ffe1e0;\n      }\n\n      .cls-16 {\n        fill: #dc8627;\n      }\n\n      .cls-4 {\n        fill: #29150d;\n      }\n\n      .cls-17, .cls-6 {\n        fill: #914b2c;\n      }\n\n      .cls-5 {\n        stroke: #6eaeff;\n      }\n\n      .cls-6, .cls-10 {\n        stroke: #692e14;\n      }\n\n      .cls-7 {\n        fill: #e53a31;\n      }\n\n      .cls-8 {\n        fill: #d1e6ff;\n        stroke: #a3ccff;\n      }\n\n      .cls-18 {\n        fill: #f5ce9d;\n      }\n\n      .cls-9 {\n        stroke: #ff7d7a;\n      }\n\n      .cls-19 {\n        fill: #783e24;\n      }\n\n      .cls-20 {\n        fill: #f7cdcb;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M77.09,217.43c.13,1,.92,37.62.92,37.62h15.51l6.3-5.66v-31.96h-22.73Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-10",
    x1: 90.87,
    y1: 219.14,
    x2: 90.87,
    y2: 251.39
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "25.8 202.21 25.8 226.2 169.15 236.08 165.23 210.78 25.8 202.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M93.52,31.35L0,71.12l4.02,220.93h14.27l9.86-5.67s-2.02-83.51-2.35-84.18,119.11-72.41,118.23-73.75S93.52,31.35,93.52,31.35Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "93.52 135.61 25.8 172.76 25.8 202.21 152.46 210.78 185.9 160.33 145.52 140.74 93.52 135.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M136,152.38c.36,7.05-4.02,26.78,6.45,29.45,4.88,1.24,7.36-2.24,8.12-7.39,1.12-7.56,2.7-16.31,1.78-23.9-.28-2.32-.91-4.28-3.4-5.01-4.23-1.23-11.05,4.12-12.95,6.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M92.44,67.19c-3.62,2.29-4.48,3.58-8.05,5.93-7.86,5.19-15.76,10.27-23.51,15.62-4.98,3.44-9.58,8.01-13.62,12.45-1.11,1.22-1.92,3.09-3.13,4.14-1.84,1.6-5.6,1.7-8.11,2.39-3.18.87-10.33,1.96-10.22,6.31.06,2.53,3.79,6.39,5.43,8.01.87.86,2.21,1.29,3.06,2.21,1.88,2.03,2.23,5.7,3.47,8.47,3.93,8.75,10.61,15.25,18.18,20.94,8.53,6.42,17.41,11.32,27.7,13.99,3.85,1,7.73.87,11.71,1.1,1.2,3.74,6.53,6.75,10,7.9s6.23-.3,6.4-4.04c.11-2.6-.07-5.19-.75-7.65,6.56-3.76,12.34-9.25,18.56-13.55,6.17-4.26,12.27-8.63,18.2-13.23,4.35-3.38,9.34-7.23,12.74-11.58,2.34-2.99-7.42-8.23-5.89-11.68s10.24-11.37,10.1-15.31,1.22-9.23,0-12.74c-2.23-6.43-4.88-6.38-9.15-11.58-6.33-7.69-14.53-15.77-24.06-19.47-8.05-3.13-16.69-3.53-24.43.6-4.16,2.21-8.68,6.14-11.19,8.24-1.9,1.67-2.45,1.9-3.44,2.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M135.08,147.9c.62-2.79,1.98-6.86,3.1-9.49,1.96-4.62,5.48-7.79,9.32-11.06,8.21-6.99,17.75-12.56,28.56-13.93,9.74-1.23,20.92.68,29.79,4.69-2.08.78-6.9,4.9-7.37,7.12-.33,1.57,1.61,4.91,1.99,6.42,1.82,7.41-1.35,13.45-5.37,19.5-1.86,2.79-4.54,4.76-6.95,7.05-2.71,2.58-5.77,5.58-9.29,7.07-4.86,2.06-9.19,4.13-14.48,2.63-4.48-1.27-7.12-3.91-9.13-7.92-1.34-2.68-2.88-3.2-6.03-3.22-4.65-.02-10.09-.9-14.6.28.03-.28-.25-5.87.47-9.15Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 166.85,
    cy: 48.55,
    rx: 13.28,
    ry: 13.17
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 142.84,
    y: 104.17,
    width: 19.23,
    height: 31.23,
    rx: 9.62,
    ry: 9.62,
    transform: "translate(-41.29 127.04) rotate(-40.3)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 117.82,
    cy: 64.48,
    rx: 55.09,
    ry: 62.81,
    transform: "translate(-9.09 108.43) rotate(-47.79)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M57.7,32.28c-4.4,2.4-6.2,8.96-1.14,11.65,3.91,2.08,9.52,1.56,13.78,1.37,4.46-.2,8.9-.06,13.33.52,3.32.44,6.81,1,10.06,1.83,2.41.62,5.8,1.82,7.89-.33,1.72-1.77.64-4.21-.6-5.89-1.83-2.49-5.11-3.14-7.86-4.25-4.5-1.83-9.29-3.4-14.12-4.03-3.44-.45-6.9-.74-10.32-1.32.15.04-7.72-1.36-11.04.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M91.31,61.47c1.99-.29,3.83-1.01,4.11-2.86.96-6.45-5.75-7.12-10.5-7.82-2.53-.37-5.08-.32-7.62-.56-1.89-.17-3.76-.38-5.64-.61-6.01-.72-12.16-.5-18.22-.3,0,.08.02.16.05.22-2.93,1.61-3.23,7.03-1.24,9.59,1.67,2.15,4.87,1.73,7.28,1.61,4.41-.21,8.73-.28,13.15-.06,4.78.23,9.63,1.17,14.42,1.01,1.08-.03,2.69,0,4.21-.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M91.97,71.59c-1.82,1.53-4.79,2.09-6.78,2.44-6.22,1.07-12.73.41-19.01.49-2.09.03-4.21.08-6.3.03-1.42-.04-2.85-.06-3.83-1.27s-1.46-3.98-.72-5.69c.8-2.58,7.06-3.26,8.85-3.14,4.37.3,8.76.84,13.13,1,3.97.14,7.99-.38,11.93.02,2.17.22,5.22,1.61,4.02,4.45-.28.66-.73,1.22-1.28,1.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M59.78,80c.11-1.21,2.6-1.63,3.58-1.84,2.14-.47,4.08-.74,6.28-.74,4.09,0,8.21-.04,12.29-.4,1.57-.14,3.13-.12,4.7-.2,1.14-.06,2.44-.24,3.58-.09,1.77.22,3.26,1.17,3.87,2.89,2.67,7.49-8.63,7.84-13.06,7.66-3.81-.15-7.39.67-11.06,1.58-2.01.5-4.22,1.22-6.23.41-3.28-1.3-4.12-7.3-3.95-9.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M66.06,93.58c.15-1.55,3.76-2.31,4.99-2.58,2.57-.57,5.1-1.03,7.74-1.15,3.81-.17,7.65.03,11.44-.51,2.03-.29,4.61-.34,4.65,2.48s-3.08,4.71-5.35,5.35-4.61.54-6.96.78c-1.91.2-3.81.46-5.69.84-2.59.52-5.46,1.48-7.93.09-1.25-.7-2.34-1.6-2.6-3.04-.13-.73-.61-3.11-.28-2.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M161.78,23c1.86,2.83.44,6.04-.1,9.04-.41,2.28-2.22,2.41-4.22,1.59-2.35-.96-3.5-4.4-2.43-6.42.07-.13,2.96-9.97,6.74-4.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M153.5,13.87c-.46-1.19-1.22-2.24-2.31-2.83-3.07-1.65-5.26,1.72-5.57,4.32-.29,2.44.23,5,.7,7.46.42,2.21.89,2.98,2.33,3.79,1.12.63,1.97.69,3.21-.37.98-.84,1.02-2.82,1.29-4.06.32-1.49.79-3.01.91-4.53.09-1.18-.08-2.56-.56-3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M137.9,6.15c-1.21-1.23-2.65-2.23-4.37-2.89-3-1.14-6.09.33-4.31,3.76,1.57,3.03,4.89,5.01,6.77,7.89,1.24,1.9,1.68,3.9,1.7,6.04,0,2.64,2.32,7.69,5.41,5.11,1.77-1.48,1.32-4.68.85-6.56-.78-3.19-1.57-6.38-3.12-9.25-.81-1.51-1.77-2.9-2.93-4.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M134.74,26.01c-1.42.58-2.9,1-4.15-.03s-1.75-3.47-2.61-4.75c-.96-1.44-1.94-2.88-2.9-4.32-1.88-2.82-3.96-5.29-6.66-7.36-1.78-1.37-5.36-2.49-6.02-4.89-.32-1.17.57-1.93,1.24-2.89,1.34-1.92,5.2-2,6.8-1.5,1.94.61,3.35,2.2,4.74,3.61,2.08,2.11,3.1,4.78,4.62,7.28,1.23,2.02,2.66,3.86,4.06,5.75.65.87,1.37,1.85,1.81,2.84.59,1.32,1.15,3.07.85,4.49-.16.74-1.12,1.51-1.79,1.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M127.49,27.9c-.16.26-.39.51-.68.72-.98.72-1.96,1.06-3.18.83-2.2-.41-3.88-2.22-5.49-3.79-2.59-2.53-4.68-5.57-7.14-8.24-2.02-2.19-4.37-3.95-6.73-5.74-1.22-.92-2.53-1.63-3.91-2.28-1.18-.55-2.61-.82-3.42-1.93-1.08-1.47-.65-3.45.6-4.48,1.68-3.76,8-2.45,10.56-.52s4.17,5,6.42,7.23c3.93,3.9,8.56,6.74,11.3,11.73.91,1.66,2.81,4.58,1.66,6.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M120.95,33.1c-.05.4-.19.79-.45,1.13-1.28,1.65-3.21,2.05-5.1,1.47-2.59-.8-4.1-2.41-6.03-4.16-2.07-1.87-4.24-3.76-6.43-5.49-3.22-2.54-6.58-4.06-10.33-5.78-3.44-1.58-8.16-2.35-11.28-4.75-.94-.72-1.71-3.79-.72-4.78.52-1.37,2.51-2.8,3.56-3.13,1.83-.57,3.95-.79,5.85-.44,2.9.53,5.3,2.52,7.62,4.2,3.03,2.19,6.23,4.19,9.32,6.3,2.27,1.55,4.29,3.5,6.35,5.3,2.38,2.08,5.21,3.77,6.71,6.67.49.95,1.08,2.29.94,3.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M106.41,40.92c-2.2-.46-4.53-1.52-5.46-2.1-1.84-1.15-3.24-2.91-5.08-4.1s-3.82-2.33-5.7-3.52-4.06-1.63-6.12-2.45-4.02-.72-6.04-1.34c-1.84-.56-4.42-1.19-6.3-.65-1.31.38-5.23.87-6.4-.65-1.07-1.39-.34-6.41,2.66-8.28,1.74-1.08,5.66-2.1,7.53-2.12,3.94-.04,7.86,3.02,11.07,4.73,2.04,1.09,4.03,2.24,6.03,3.38,4.95,2.84,10.22,5.09,14.68,8.71,1.72,1.39,5.07,4.99,3.6,7.51-.72,1.22-2.54,1.28-4.47.87Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.84,68.37c8.15-3.75,15.53-8.34,19.63-16.36"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.12,41.79c3.6.44,6.52,1.43,10.25.99,3.52-.41,7.78-1.17,11.01-2.82.62-.31,1.32-.65,1.84-1.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.8,58c4.46,1.37,10.18.69,13.21-3.24,1.22-1.58,1.99-3.62,2.32-5.57.07-.45.24-2.01.23-1.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.31,81.9c4.08,1.08,9.61-.95,12.68-3.67,2.48-2.19,4.47-6.06,4.29-9.45"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.96,66.06c1.53,3.08,7.05,3.41,7.13,7.49.06,3.11-3.53,6.15-6.2,6.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M164.62,92.07c-.27,1.52-1.4,3.39-2.69,4.77-.54.59-1.11,1.09-1.65,1.44-1.93,1.23-4.13,2.32-6.26,3.14-.63.24-5.99,3.19-5.64,1.39-.98-1.1-.63-3.55-.74-4.95-.05-.62-.05-1.21-.01-1.78.07-.82.26-1.62.62-2.47.98-2.32,2.77-4.33,4.99-5.52,3.42-1.84,12.5-2.34,11.38,3.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M161.93,96.84c-.54.59-1.11,1.09-1.65,1.44-1.93,1.23-4.13,2.32-6.26,3.14-.63.24-5.99,3.19-5.64,1.39-.98-1.1-.63-3.55-.74-4.95-.05-.62-.05-1.21-.01-1.78,1.33-.41,2.74-.56,4.16-.69,2.47-.23,5.32-.58,7.73.19.77.25,1.73.65,2.41,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M246.06,119.92c8.94.63,17.91.82,26.85,1.49,14.81,1.1,29.64,1.84,44.47,2.48,26.89,1.15,53.21,3.81,79.4,8.63,9.27,1.71,35.82,2.69,36.93,15.2,2.28,25.63-25.51,32.96-37.93,49.59-15.11,20.22-7.19,44.57-9.53,68.04-8.54-1.59-14.14-.93-22.47.32-7.67,1.15-69.89-8.27-95.16-9.37-28.93-1.26-51.62-1.24-86.59-4.9-14.58-1.53-22.05-.93-24.26-16.86-3.18-23.01,8.43-54.66,23.69-72.07,10.23-11.67,23.99-20,36.53-29.01,4.88-3.51,7.45-9.53,11.88-14.11,1.57-1.63,10.39.17,16.19.58Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "25.8 172.76 154.09 182.36 149.96 210.78 25.8 202.21 25.8 172.76"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M201.39,122.37c-5.53,3.73-10.77,8.06-15.92,12.32-11.18,9.24-21.83,22.39-32.05,32.58-4.34,4.33-8.56,9.65-10.79,16.83s-1.32,32.29-1.1,38c.17,4.45-1.97,30.05-.74,31.73s12,2.71,17.77,2.43,13.47.45,14.83-1.78c.85-1.4,2.18-32.23,1.81-40.09-.36-7.88-.54-16,.8-23.79,1.25-7.28,5.32-11.69,9.88-17.31,12.08-14.87,25.85-27.99,41.08-39.59,2.5-1.9,17.5-13.57,14.15-15.18s-9.86-2.85-13.24-3.6c-4.04-.9-10.89-2.54-13.69-1.16-.38.19-8.95,6.03-12.81,8.64Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 80.26,
    cy: 107.77,
    rx: 14.23,
    ry: 13.96
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M209.05,130.89c.17.01.34.02.51.02,2.26.03,5.31-.04,6.59-2.23.51-.88,1.03-2.62.78-3.6-.76-2.96-6.04-4.26-8.41-5.21-2.59-1.04-5.28-1.86-7.99-2.46-1.43,0-3.39.56-4.2.92-2.58,1.15-5.47,4.87-2.88,7.31,2.11,1.99,5.51,2.44,8.2,3.29,2.43.77,4.85,1.82,7.41,1.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M207.54,123.42c2.15-1.62,7.03-1.64,8.9.61,2.51,3.03.44,8.29-2.17,10.6-5.12,4.51-10.43,7.05-16.05,9.15-2.81,1.05-5.29,2.65-7.97,3.93-2.09,1-7.06,2.57-8.11-.74-.54-1.69,1.32-4.32,2.14-5.66,1.25-2.05,2.95-3.51,4.94-4.84,3.13-2.1,6.58-2.67,9.86-4.26,2.07-1,3.55-2.23,5.33-3.71.96-.79,1.57-1.48,2.33-2.45.52-.66.98-.92,1.07-1.48.04-.23-.52-1.27-.26-1.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M75.69,109.19c.72-5.03,10.04-7.59,13.81-7.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M90.5,149.47c3.31,2.59,6.22,5.49,8.1,8.88,1.95,3.5,1.32,6.21-3.09,5.72-9.22-1.02-29.16-11.86-35.96-16.31-2.48-1.62-9.22-7.47-11.67-10.65-3.38-4.39-6.15-7.93-6.71-12.64s1.71-4.63,5.57-3.43c11.19,3.49,18.95,11.99,28.48,18.35,4.61,3.08,10.38,6.24,15.27,10.08Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "54.97 55.39 14.24 72.86 18.38 290.13"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 2.42,
    y1: 72.61,
    x2: 14.24,
    y2: 72.86
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.5,187.26c40.57.94,50.14,2.56,91.46,5.32,14.57.97,80.72,4.01,93.52,4.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "431.51 139.47 384.85 182.36 384.85 317.33 398.05 317.87 406.66 311.41 406.96 251.39 430.8 229.73 431.49 269.8 440.24 271.03 445.35 267.18 444.37 141.29 431.51 139.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M442.37,143.63c-2.23,1.49-42.67,38.47-42.67,38.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M396.63,184.75c0,13.86,1.02,120.75,1.02,129.34"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 429.62,
    y1: 230.94,
    x2: 438.55,
    y2: 222.17
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 440.26,
    y1: 150.54,
    x2: 440.24,
    y2: 269.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M187.39,124.66c1.7.98,3.57,1.6,5.32,2.49,1.04.52,2.08,1.03,3.19,1.34,1.18-2.4,2.65-4.45,4.61-6.3,1.52-1.43,2.89-3.07,4.7-4.1-1.06-.48-2.21-.64-3.36-.88-1.22-.26-2.35-.79-3.55-1.06-1.48-.34-3.22-.12-4.73-.24.19-.08.38-.1.59-.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M181.79,122.69c3.58,2.83,9.19,3.11,12.84,5.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M153.69,144.08c1.04,4.14-.35,8.95-.35,12.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M152.35,137.6c5.41,2.57,11.27.46,15.44-3.69,2.33-2.32,3.88-6.87,2.44-10.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M192.43,147.97c-1.6.91-6.6,1.12-7.9,2.2-6.18,5.13-20.82,23.62-28.79,28.14-2.61,1.48-4.76,3.32-7.69,3.91-1.81.36-7.94.33-9.67-3.6-1.22-2.79-1.62-4.82.37-7.31s5.14-3.68,7.84-5.33c2.13-1.3,4.18-2.94,6.22-4.4,2.41-1.85,4.88-3.63,7.36-5.49,3.94-2.96,14.16-11.78,19.61-15.8,5.3-3.91,5.45-5.1,12.66-6.02s11.64,5.27,7.79,9.27c-2.81,2.91-1.23.72-7.79,4.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M188.78,137.77c1.82-1.06,3.9-1.64,5.98-1.96.81-.13,1.77-.3,2.57-.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M190.91,140.56c1.93-1.01,4.17-1.81,6.32-2.19.66-.12,2.38-.53,2.99-.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M193.34,143.8c1.99-1.65,4.9-1.53,7.29-1.92"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleep);
export default __webpack_public_path__ + "static/media/sleep.8afae65592ea026e7097f4faa979f1c6.svg";
export { ForwardRef as ReactComponent };